import Repository from "./Repository";

const WITHDRAW = "/import-ticket-holder";
export default {
  setTickets(payload) {
    console.log(payload);
    return Repository.post(`${WITHDRAW}`, payload);
  },
};
